import { testimonials } from "@/mocks/guaData";
import SectionHeading from "./SectionHeading";

const values = [
  { icon: "ri-chat-3-fill", title: "聚焦评论区", text: "把镜头对准评论区，神回复、名场面才是真正的看点。" },
  { icon: "ri-focus-3-line", title: "人工精选", text: "每条神评都经过人工挑选归档，宁缺毋滥，保证笑点密度。" },
  { icon: "ri-archive-drawer-line", title: "按频道归档", text: "按兴趣分频道整理，想找哪类瓜都能快速翻到，不迷路。" },
  { icon: "ri-shield-check-line", title: "克制且尊重", text: "只收公开幽默内容，规避隐私与争议，理性吃瓜不添乱。" },
];

export default function About() {
  const orgSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        name: "呱呱吃瓜",
        description: "专注汇聚中文互联网评论区精华的吃瓜娱乐内容站",
        url: "https://teweijiale.cn/",
        slogan: "评论区才是瓜的精华",
      },
      {
        "@type": "WebSite",
        name: "呱呱吃瓜",
        url: "https://teweijiale.cn/",
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <section id="about" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <SectionHeading
            center
            kicker="关于呱呱 · 口碑与理念"
            title="一个把评论区当主场的吃瓜站"
            desc="呱呱吃瓜的诞生，源于一句被反复印证的话——评论区才是瓜的精华。我们想做的，就是把那些藏在长楼里的高光时刻捞起来给你看。"
          />

          {/* 品牌叙事 */}
          <div className="mt-10 grid items-center gap-10 lg:grid-cols-2">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20people%20gathering%20around%20a%20giant%20table%20of%20watermelons%20laughing%20and%20scrolling%20phones%2C%20community%20gossip%20theme%2C%20cream%20green%20and%20warm%20tones%2C%20playful%20minimalist%20cartoon%20style%2C%20cheerful%20and%20cozy%2C%20no%20text&width=900&height=700&seq=about-melon-01&orientation=portrait"
                alt="呱呱吃瓜社区吃瓜名场面插画"
                title="呱呱吃瓜社区吃瓜插画"
                className="h-[340px] w-full rounded-3xl object-cover object-top"
              />
              <div className="absolute -bottom-5 left-4 rounded-2xl border border-background-200 bg-background-50 px-5 py-3 shadow-sm md:left-8">
                <p className="text-xs text-foreground-500">核心理念</p>
                <p className="font-heading text-lg text-primary-700">评论区才是瓜的精华</p>
              </div>
            </div>

            <div>
              <p className="text-[15px] leading-relaxed text-foreground-700">
                你刷过那样的帖子吗？正文平平无奇，评论区却人才辈出、笑点密集，一楼接一楼把气氛推向高潮。
                呱呱吃瓜就是为这样的瞬间而生——我们把「吃瓜」的重点从楼主正文，转移到真正决定「好不好看」的评论区。
              </p>
              <p className="mt-4 text-[15px] leading-relaxed text-foreground-700">
                在这里，神回复被单独拎出来、名场面有了自己的名字、热梗被忠实记录。不用自己翻几十层楼，看热闹，就看这层楼。
              </p>

              <ul className="mt-6 grid gap-3 sm:grid-cols-2">
                {values.map((v) => (
                  <li key={v.title} className="flex gap-3 rounded-xl border border-background-200 bg-background-50 p-3">
                    <i className={`text-xl ${v.icon} mt-0.5 text-primary-600`}></i>
                    <div>
                      <p className="text-sm font-semibold text-foreground-800">{v.title}</p>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-600">{v.text}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* 用户口碑 */}
          <div className="mt-16">
            <h3 className="text-center font-heading text-2xl text-foreground-900 md:text-3xl">常驻瓜田的他们这样说</h3>
            <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {testimonials.map((t) => (
                <figure
                  key={t.name}
                  className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:shadow-sm"
                >
                  <div className="flex items-center gap-1 text-secondary-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
                  <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-sm font-semibold text-accent-700">
                      {t.name.charAt(0)}
                    </span>
                    <div className="min-w-0">
                      <p className="truncate text-sm font-medium text-foreground-800">{t.name}</p>
                      <p className="truncate text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}